import { useState, useRef, useEffect } from 'react';

export const useDraggable = (initialX = 100, initialY = 100) => {
  const [position, setPosition] = useState({ x: initialX, y: initialY });
  const modalRef = useRef(null);
  const dragData = useRef({ dragging: false, offsetX: 0, offsetY: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (dragData.current.dragging) {
        setPosition({
          x: e.clientX - dragData.current.offsetX,
          y: e.clientY - dragData.current.offsetY,
        });
      }
    };

    const handleMouseUp = () => {
      dragData.current.dragging = false;
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  const startDrag = (e) => {
    // Prevent dragging from button clicks
    if (e.target.closest('button')) return;

    const modal = modalRef.current;
    if (!modal) return;
    
    const rect = modal.getBoundingClientRect();
    dragData.current.dragging = true;
    dragData.current.offsetX = e.clientX - rect.left;
    dragData.current.offsetY = e.clientY - rect.top;
  };

  const resetPosition = () => {
    setPosition({ x: initialX, y: initialY });
  };

  return {
    position,
    modalRef,
    startDrag,
    resetPosition
  };
};
